require('intersection-observer');

// Responsive Background images
// ----------------------------
(function ($) {
    const $body = $('body'),
        inBackend = $body.hasClass('neos-backend'),
        intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                let $element = $(entry.target),
                    img = $element.find('img')[0],
                    src = $element.css('background-image');

                function update() {
                    let newSrc = typeof img.currentSrc !== 'undefined' ? img.currentSrc : img.src;
                    if (newSrc !== src) {
                        src = newSrc;
                        $element.css('background-image', 'url("' + src + '")').addClass('ready');
                    }
                    observer.unobserve(entry.target);
                }

                if (entry.isIntersecting) {
                    img.complete ? update() : $(img).bind('load', function () { update(); });
                }
            });
        }, {
            rootMargin: '100px'
        });

    $.fn.responsiveBackgroundImage = function () {
        return this.each(function () {
            const $element = $(this),
                img = $element.find('img')[0];

            if (typeof img === 'undefined') {
                return;
            }

            intersectionObserver.observe(this);
        });
    };


    $(function () {
        $('[data-responsive-background-image]').responsiveBackgroundImage();
        if (inBackend && typeof document.addEventListener === 'function') {
            document.addEventListener('Neos.NodeSelected', function(event) {
                // Re-apply responsive images when node changed/selected
                $(event.detail.element).filter('[data-responsive-background-image]').responsiveBackgroundImage();
            }, false);
        }
    });
})(jQuery);
